// Custom JS Application Code
function validate_email_js(email) { var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/; if(reg.test(email) == false) { return false; } return true; }
var ellipsisText = function (e, etc) { var wordArray = e.innerHTML.split(" "); while (e.scrollHeight > e.offsetHeight) { wordArray.pop(); e.innerHTML = wordArray.join(" ") + (etc || "..."); } };

function checkHeaderOffset() {
	var $window = $(window);
	var offset = $window.scrollTop();
	if (offset>=120) {
		$('#headerWrapper').addClass('scrolled');
	}else{
		$('#headerWrapper').removeClass('scrolled');
	}
}

function checkSearchPlaceholderTexts() {
	if ($(window).width() < 768 ) {
		$('.consultants-search-wrapper .search-input').attr("placeholder",js_vars.vars.searchMobileText);
	}
	else {
		$('.consultants-search-wrapper .search-input').attr("placeholder",js_vars.vars.searchConsultantDesktopText);
	}
}

function checkTestimonialsArrows() {
	var myWidth, myHeight;
	if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
	var contentWidth = 0;
	var margins = 0;
	browserWidth = myWidth;
	browserHeight = myHeight;

	contentWidth = $('.testimonial-item > .container').width();
	margins = (browserWidth-contentWidth)/2;
	$('.swiper-arrows-wrapper .swiper-custom-prev').css('left',margins+'px');
	$('.swiper-arrows-wrapper .swiper-custom-next').css('right',margins+'px');
}

function windowOnResize() {
	var myWidth, myHeight;
	if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
	browserWidth = myWidth;
	browserHeight = myHeight;

	checkSearchPlaceholderTexts();
	checkTestimonialsArrows();
}
function pageScroll() {
	checkHeaderOffset();
}

function scrollToSlide(slideTo) {
	$('body,html').animate({ scrollTop: $('.'+slideTo).offset().top-$('header').height() }, 800);
}

var inLoadMoreAjax = false;
function preloadImages(arr){
	var newimages=[], loadedimages=0
	var postaction=function(){}
	var arr=(typeof arr!="object")? [arr] : arr
	function imageloadpost(){
		loadedimages++
		if (loadedimages==arr.length){
			postaction(newimages) //call postaction and pass in newimages array as parameter
		}
	}
	for (var i=0; i<arr.length; i++){
		newimages[i]=new Image()
		newimages[i].src=arr[i]
		newimages[i].onload=function(){ imageloadpost() }
		newimages[i].onerror=function(){ imageloadpost() }
	}
	return { //return blank object with done() method
		done:function(f){
			postaction=f || postaction //remember user defined callback functions to be called when images load
		}
	}
}

function loadMorePosts() {
	if (!inLoadMoreAjax) {
		setLoadMoreLoading();
		inLoadMoreAjax = true;
		$.ajax({ type: 'POST', url: js_vars.vars.ajaxurl, data: {
			'offset_counter' : js_vars.vars.offsetCounter,
			'num_page_items' : js_vars.vars.pageItems,
			'wpml_lang' : js_vars.vars.my_current_lang,
			'tax_id' : taxID,
			'search_query' : (typeof searchQuery !== 'undefined' ? searchQuery : ''),
			'action': 'load_more_posts'
		}, success: function (result) {
			var imagesToLoad = [];
			result.data.forEach(function(element) { if (element.image!='') imagesToLoad.push(element.image); });
			if (imagesToLoad.length) {
				preloadImages(imagesToLoad).done(function(images) { setPostsItems(result); });
			}else{
				setPostsItems(result);
			}
		}, error: function () {} });
	}
}

function setPostsItems(postItems) {
	var visibleItems = 0;
	var countItems = 1;

	postItems.data.forEach(function(elem) {
		var listItems = $('.news-list');
		var $newItem = $('<div></div>').addClass('news-item');
		var $metaElem = $('<div></div>').addClass('meta-info');
		var $imageElem = $('<div></div>').addClass('image');
		var $infoElem = $('<div></div>').addClass('info');


		$metaElem.append('<span class="date">'+elem.date+'</span>');
		$metaElem.append(elem.tags_html);

		if (elem.image!='') { $imageElem.css('background-image','url(\''+elem.image+'\')'); }

		$infoElem.append('<h3><a href="'+elem.link+'">'+elem.title+'</a></h3>');
		$infoElem.append('<p>'+elem.description+'</p>');
		$infoElem.append('<div class="btns-wrapper"><a href="'+elem.link+'" class="button btn-primary">'+js_vars.vars.readNews+'</a></div>');

		$newItem.append($metaElem);
		$newItem.append($imageElem);
		$newItem.append($infoElem);

		listItems.append($newItem);

		visibleItems++;
		js_vars.vars.offsetCounter++;
		countItems++;
	});
	if (visibleItems>0) {
		inLoadMoreAjax = false;
	}
	if (visibleItems<js_vars.vars.pageItems || visibleItems==0 || totalPosts==$('.news-list .news-item').length) { $('.load-more-wrapper').hide(); }
	unsetLoadMoreLoading();
}

function setLoadMoreLoading() { $('.load-more-wrapper').addClass('is-loading'); $('.load-more-wrapper a').text(js_vars.vars.loading); }
function unsetLoadMoreLoading() { $('.load-more-wrapper').removeClass('is-loading'); $('.load-more-wrapper a').text(js_vars.vars.readMore); }

function loadMoreTeam() {
	//quando pesquisa - vou "corrigir tudo da lista"
	//ao fazer view more
		//vou buscar os que tenho + 9
		//se o total a mostrar > todos os search item, então escondo o load more
	var allItems = $('.consultants-list .consultant-item.is-search-item');
	var hiddenItems = $('.consultants-list .consultant-item.is-search-item.hide-item');
	var availableItems = allItems.length-hiddenItems.length;
	var totalItems = allItems.length;
	var showItems = availableItems+teamPageItems;
	var countItems = 1;

	allItems.each(function() {
		if ($(this).hasClass('is-search-item') && countItems<=showItems) {
			$(this).removeClass('hide-item');
			countItems++;
		}
	});

	if (showItems>=totalItems) {
		$('.load-more-wrapper').hide();
	}
}

function searchConsultants() {
	var inputValue = $('.consultants-search-wrapper .search-input').val().toUpperCase();
	var showAll = inputValue.length==0;
	if (inputValue.length>=3 || showAll) {
		//make search
		var availableItems = 0;
		var hiddenItems = 0;
		var countItems = 0;
		var countClass = 1;
		var allItems = $('.consultants-list .consultant-item');

		allItems.removeClass('ci-1');
		allItems.removeClass('ci-2');
		allItems.removeClass('ci-3');

		allItems.removeClass('is-search-item');
		allItems.removeClass('hide-item');

		allItems.each(function() {
			var title = $(this).data('title');
			var location = $(this).data('location');
			var role = $(this).data('role');
			var isValid = false;
			if (title.toUpperCase().indexOf(inputValue) !== -1) { isValid = true; }
			if (location.toUpperCase().indexOf(inputValue) !== -1) { isValid = true; }
			if (role.toUpperCase().indexOf(inputValue) !== -1) { isValid = true; }
			if (isValid || showAll) {
				$(this).addClass('is-search-item');
				$(this).addClass('ci-'+countClass);
				availableItems++;
				countItems++;
				countClass++;
				if (countClass>3) { countClass = 1; }
				if (countItems>teamPageItems) {
					hiddenItems++;
					$(this).addClass('hide-item');
				}
			}else{
				$(this).addClass('hide-item');
			}
		});

		if (availableItems>teamPageItems) {
			$('.load-more-wrapper').show();
		}else{
			$('.load-more-wrapper').hide();
		}
	}
}

function initMap() {
	var currentMap = $('#map');
	var mymap = L.map('map',{/*zoomControl: false,*/ scrollWheelZoom: false}).setView([currentMap.data('latitude'), currentMap.data('longitude')], 15);
	var markerIcon = new L.Icon({
		iconUrl: js_vars.vars.templateurl+'/assets/img/marker-icon.png',
		iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34]
	});
	var marker = L.marker([currentMap.data('latitude'), currentMap.data('longitude')], {icon: markerIcon}).addTo(mymap);

	L.tileLayer('https://api.mapbox.com/styles/v1/sitesitio/cklfhfdu36rdd17k4f5ulwnm9/tiles/256/{z}/{x}/{y}@2x?access_token={accessToken}', {
		maxZoom: 18,
		tileSize: 512,
		zoomOffset: -1,
		accessToken: 'pk.eyJ1Ijoic2l0ZXNpdGlvIiwiYSI6ImNraXVnbmJhMTE0YmsycXNjajZwNzA5Z2YifQ.7N1DjiTwer-0UVqqJH1IbQ'
	}).addTo(mymap);
}

(function($) {
	"use strict"; // Start of use strict
	$(window).bind('hashchange');
	$(window).trigger('hashchange');
	$(window).scroll( function() { /*disableScroll();*/ pageScroll(); } );
	$(window).resize(function() { windowOnResize(); });
	$(window).ready(function() {
		var myWidth, myHeight;
		if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
		browserWidth = myWidth;
		browserHeight = myHeight;

		//if ($(window).width()>=1024) { new WOW().init(); }

		//$('.go-top a').click(function () { $('body,html').animate({ scrollTop: 0 }, 800); $(this).blur(); return false; });

		$('.main-nav li > ul').each(function() {
			var liParent = $(this).parent();
			var liLink = $(this).parent().find('> a');;
			$(this).addClass('sub-menu');
			liParent.addClass('sub-nav-toggle');
		});

		$('.nav-toggle').bind('click',function(ev) {
			if ($('.nav-wrapper').hasClass('opened')) {
				$('.nav-wrapper').fadeOut(0,function() {
					$(this).removeClass('opened');
					$('#headerWrapper').removeClass('opened');
				});
				$(this).removeClass('is-active');
			}else{
				$('#headerWrapper').addClass('opened');
				$('.nav-wrapper').fadeIn(0,function() {
					$(this).addClass('opened');
				});
				$(this).addClass('is-active');
			}

			$(this).blur();
			ev.preventDefault();
		});

		if (browserWidth>=1024) {
			$('.sub-nav-toggle').hover(function(ev) {
				$('#headerWrapper').addClass('show-sub-nav');
				$('#headerWrapper').removeClass('fixed-sub-nav');
			},function(ev) {
				$('#headerWrapper').removeClass('show-sub-nav');
				if ($('#headerWrapper').hasClass('has-fixed-sub-nav')) {
					$('#headerWrapper').addClass('fixed-sub-nav');
				}
			});
		} else {
			$('.sub-nav-toggle > a').bind('click',function(ev) {
				$(this).parent().find('ul').slideToggle();
				$(this).blur(); ev.preventDefault();
			});
		}

		$('.cookies-popup .btn-wrapper a').bind('click',function(ev) {
			var popupHeight = $('.cookies-popup-wrapper').height();
			$('.cookies-popup-wrapper').animate({bottom: '-'+popupHeight+'px'},function() { $('.cookies-popup-wrapper').remove(); });
			Cookies.set('cookies_accepted', '1', { expires: 90 });
			$(this).blur(); ev.preventDefault();
		});
		if (Cookies.get('cookies_accepted')==undefined) { $('.cookies-popup-wrapper').show(); }

		checkSearchPlaceholderTexts();

		$('.open-talent-popup').bind('click',function(ev) {
			var dataID = $(this).data('id');
			$('#talentPopup'+dataID).fadeIn();
			$('body').addClass('in-popup');
			$(this).blur(); ev.preventDefault();
		});

		$('.close-popup').bind('click',function(ev) {
			$(this).closest('.popup-wrapper').fadeOut();
			$('body').removeClass('in-popup');
			$(this).blur(); ev.preventDefault();
		});

		$('.newsletter-submit').bind('click',function(ev) {
			var nEmail = $('#nEmail').val();
			if (nEmail!='' && validate_email_js(nEmail)) {
				$('#acceptancePopupWrapper').fadeIn();
				$('body').addClass('in-popup');
			}else{
				$('#formError').fadeIn();
				$('body').addClass('in-popup');
			}
			$(this).blur(); ev.preventDefault();
		});

		$('.newsletter-acceptance-submit').bind('click',function(ev) {
			var gdprAcceptance = $(this).closest('.popup-wrapper').find('.gdpr-acceptance-newsletter');
			if (gdprAcceptance.hasClass('accepted')) {
				var formParent = $('#nEmail').closest('.newsletter-form');
				formParent.find('input.wpcf7-submit').click();
				/*
				$(this).closest('.popup-wrapper').fadeOut();
				$('#formNewsletterSuccess').fadeIn();
				*/
				$(this).closest('.popup-wrapper').find('.gdpr-acceptance-newsletter').toggleClass('accepted');
				$(this).toggleClass('disabled');
				/*
				$('#nEmail').val('');
				*/
			}
			$(this).blur(); ev.preventDefault();
		});

		$('.gdpr-acceptance').bind('click',function(ev) {
			$(this).closest('.form-wrapper').find('.form-bottom a.button').toggleClass('disabled');
			$(this).toggleClass('accepted');
			$(this).blur(); ev.preventDefault();
		});

		$('.gdpr-acceptance-newsletter').bind('click',function(ev) {
			$(this).closest('.message-wrapper').find('.newsletter-acceptance-submit').toggleClass('disabled');
			$(this).toggleClass('accepted');
			$(this).blur(); ev.preventDefault();
		});

		$('.career-item a.button').bind('click',function(ev) {
			$('input[name=job-offer]').val($(this).data('title'));
			$('.job-offer-field').text($(this).data('title'));
			$('#careersFormPopup').fadeIn();
			$('body').addClass('in-popup');
			$(this).blur(); ev.preventDefault();
		});

		$('.open-contact-form').bind('click',function(ev) {
			$('#contactFormPopup').fadeIn();
			$('body').addClass('in-popup');
			$(this).blur(); ev.preventDefault();
		});

		$('.contact-form-submit').bind('click',function(ev) {
			var formParent = $(this).closest('.form-wrapper');
			if (formParent.find('.gdpr-acceptance').hasClass('accepted')) {
				$(this).closest('.wpcf7-form').find('input.wpcf7-submit').click();
			}
			/*
			$('#contactFormPopup').fadeOut();
			$('#formContactSuccess').fadeIn();
			*/
			$('body').addClass('in-popup');
			$(this).blur(); ev.preventDefault();
		});
		$('.career-form-submit').bind('click',function(ev) {
			var formParent = $(this).closest('.form-wrapper');
			if (formParent.find('.gdpr-acceptance').hasClass('accepted')) {
				$(this).closest('.wpcf7-form').find('input.wpcf7-submit').click();
			}
			/*
			$('#careersFormPopup').fadeOut();
			$('#formCareerSuccess').fadeIn();
			*/
			$('body').addClass('in-popup');
			$(this).blur(); ev.preventDefault();
		});

		$('.attachment-field').bind('click',function(ev) {
			$('#cvFile').trigger('click');
			$(this).blur(); ev.preventDefault();
		});
		$("#cvFile").change(function(){
			var fileName = $('#cvFile').val().split('\\').pop();
			$('.attachment-field span').text(' - '+fileName);
		});

		//$(parent_element_selector_here or document ).on('change','#imageFile' , function(){ uploadFile(); });


		document.addEventListener( 'wpcf7mailsent', function( event ) {
			if ( contactFormID == event.detail.contactFormId ) { //CONTACTS FORM
				$('#contactFormPopup').fadeOut();
				$('#formContactSuccess').fadeIn();
			}
			if ( careerFormID == event.detail.contactFormId ) { //CONTACTS FORM
				$('#careersFormPopup').fadeOut();
				$('#formCareerSuccess').fadeIn();
				$('.attachment-field span').text('');
			}
			if ( pageCandidaturaFormID == event.detail.contactFormId ) { //CONTACTS FORM
				$('#careersFormPopup').fadeOut();
				$('#formCareerSuccess').fadeIn();
				$('.attachment-field span').text('');
			}
			if ( newsletterFormID == event.detail.contactFormId ) { //CONTACTS FORM
				$('#acceptancePopupWrapper').fadeOut();
				$('#formNewsletterSuccess').fadeIn();
			}
		}, false );

		document.addEventListener( 'wpcf7invalid', function( event ) {
			if ( contactFormID == event.detail.contactFormId ) { //CONTACTS FORM
				/*$('#contactFormPopup').fadeOut();*/
				$('#formError').fadeIn();
			}
			if ( careerFormID == event.detail.contactFormId ) { //CONTACTS FORM
				/*$('#careersFormPopup').fadeOut();*/
				$('#formError').fadeIn();
			}
			if ( pageCandidaturaFormID == event.detail.contactFormId ) { //CONTACTS FORM
				/*$('#careersFormPopup').fadeOut();*/
				$('#formError').fadeIn();
			}
			if ( newsletterFormID == event.detail.contactFormId ) { //CONTACTS FORM
				$('#formNewsletterError').fadeIn();
				$('#acceptancePopupWrapper').fadeOut();
			}
		}, false );

		$('.load-more-wrapper a.load-more-news').bind('click',function(ev) {
			loadMorePosts();
			$(this).blur(); ev.preventDefault();
		});

		$('.load-more-wrapper a.load-more-consultants').bind('click',function(ev) {
			loadMoreTeam();
			$(this).blur(); ev.preventDefault();
		});

		$('.search-submit').bind('click',function(ev) {
			$(this).closest('form').submit();
			$(this).blur(); ev.preventDefault();
		});

		$('form#searchform .search-submit').bind('click',function(ev) {
			$(this).closest('form').submit();
			$(this).blur(); ev.preventDefault();
		});

		$('.consultants-search-wrapper .search-submit').bind('click',function(ev) {
			searchConsultants();
			$(this).blur(); ev.preventDefault();
		});
		$(".consultants-search-wrapper .search-input").on('keyup', function (e) {
			if (e.key === 'Enter' || e.keyCode === 13) {
				searchConsultants();
			}
		});

	});
	$(window).on('load',function() {
		if ($('.careers-list').length) {
			$('.careers-list').isotope({ filter: '.career-item'/*,transitionDuration: 1000*/ });
		}

		if ($('.testimonials-swiper').length) {
			if ($('.testimonials-swiper .testimonial-item').length>1) {
				new Swiper('.testimonials-swiper.swiper-container', {
					//slidesPerView: 2,
					autoHeight: true,
					slidesPerView: 1,
					centeredSlides : false,
					spaceBetween: 0,
					loop: true,
					navigation: {
						nextEl: '.testimonials-wrapper .swiper-custom-next',
						prevEl: '.testimonials-wrapper .swiper-custom-prev',
					},
					pagination: {
						el: '.testimonials-wrapper .swiper-pagination',
						type: 'bullets',
						clickable: true,
					},
					/*autoplay: { delay: 5000, }*/
				});
				checkTestimonialsArrows();
			}
		}

		if ($('.hp-banners-swiper').length) {
			new Swiper('.hp-banners-swiper.swiper-container', {
				//slidesPerView: 2,
				autoHeight: true,
				slidesPerView: 1,
				centeredSlides : false,
				spaceBetween: 0,
				loop: true,
				pagination: {
					el: '.hp-banners .swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
				/*autoplay: { delay: 5000, }*/
			});
			checkTestimonialsArrows();
		}

		if ($('.map-wrapper').length) {
			initMap();
		}

	});

})(jQuery); // End of use strict


var browserWidth = 0;
var browserHeight = 0;
